import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { NolKoma7toNolKoma8 } from '../../GlobalStyles'

const Container = styled.div`
    display: grid;
    grid-template-rows: 1fr auto auto;
    gap: 12px;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 500ms;
    }
    p {
        text-transform: uppercase;
        font-size: ${NolKoma7toNolKoma8};
        text-align: center;
    }
    `
const ImgWrap = styled.div`
    overflow: hidden;
    cursor: pointer;
    &:hover img {
        transform: scale(1.3);
    }
`
export default function Card({ item }) {
  const navigate = useNavigate()
  return (
    <Container>
        <ImgWrap onClick={() => navigate('/detail')}>
            <img src={item.img} alt="gambar" />
        </ImgWrap>
        <p>{item.text}</p>
        <p>RM 139.00</p>
    </Container>
  )
}
